var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InsightsChartsTab',{attrs:{"charts":_vm.chartConfigurations,"filters":_vm.filters,"dateRange":_vm.dateRange,"pdfMode":_vm.pdfMode}})
}
var staticRenderFns = []

export { render, staticRenderFns }